import React, { useState, useEffect } from 'react';
import moment from 'moment'
import "moment/locale/es";
import { connect } from 'react-redux';
import { getCodes } from "./../actions/codes";
import { Grid, CircularProgress, Button, Container, makeStyles} from '@material-ui/core';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './../components/Codes/style/tableresponsive.css';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import StandardDialog from '../components/Complements/StandardDialog';
import { sendEmailWithVoucher } from "../actions/sendEmailWithVoucher";
import { findTransferCore } from "../actions/transferscore";
import Footer from '../components/Complements/Footer';
import { feathersCreateData } from '../services';
import QrInfo from '../components/QR/QrInfo';
import { urlQr } from '../services/urls';
import { sendMobile } from "../functions/mobile";

const useStyles = makeStyles((theme) => ({
  divStandard: {
    "& th": {
      color: theme.palette.type === "dark" ? "#ffffff" : "#000000",
    }
  }
}));

const ReportQr = props => {
    const classes2 = useStyles()
    const { devices, handleOpenSnack } = props
    const [codespaginate, setCodesPaginate] = useState([])
    const [codespaginateAll, setCodesPaginateAll] = useState([])
    const [page, setPage] = useState(1)
    const [count, setCount] = useState(1)
    const [loading, setLoading] = useState(false)
    const [dialog, setDialog] = useState({
        open: false,
        title: '',
        children: <div></div>
    })
    //const [document, setDocument] = useState('')
    const mount = () => {
        const unmount = () => {
            moment.locale('es-es')
            handleGetDataMovementsBySecuencialAccount(1)
        }
        return unmount()
    }

    const handleGetDataMovementsBySecuencialAccount = async (numberpage) => {
        try {
            setLoading(true)
            const responseData = await feathersCreateData("report-qr", {})()
            setCodesPaginate(responseData.data)
            setCodesPaginateAll(responseData.data)
            getDataViewTable(responseData.data.length, numberpage);
            setLoading(false)
            //console.log('responseDaaaaata', responseData)

        } catch (error) {
            setLoading(false)
        }
    }
    const handleChangeStatusQr = async (id) => {
        try {
            setLoading(true)

            const responseData = await feathersCreateData("process-change-status-qr", { id })()
            if (responseData.error === false) {
                handleGetDataMovementsBySecuencialAccount(1)
                handleOpenSnack("Se ha eliminado correctamente.", "success")
            } else {
                handleOpenSnack("Ha ocurrido un error al eliminar el qr.", "error")
            }
            setLoading(false)
        } catch (error) {
            handleOpenSnack("Ha ocurrido un error al eliminar el qr.", "error")
            setLoading(false)
        }
    }
    useEffect(mount, [])
    const onChangePaginationCodes = (e, page) => {
        //console.log(page)
        let init = (page - 1) * 10;//15
        let end = page * 10;//20
        let datacodespaginate = codespaginateAll.slice(init, end);;
        //console.log(datacodespaginate)
        setCodesPaginate(datacodespaginate)
        setPage(page)
    }
    const getDataViewTable = (total, numberpage) => {
        // console.log("*** CODES ***", codes)
        let contador = parseInt((total / 10).toString());
        let residuo = total % 10;
        if (residuo > 0) {
            contador++;
        }
        setCount(contador)
        setPage(numberpage)
    }
    const handlePrint = (document) => {
        //let document = row.fileName
        window.open(urlQr + document + ".pdf", '_blank');
    }
    const handleViewVoucher = (row) => {
        //console.log("MOVIMIENTO SELECCIONADO: ", row)
        setDialog({
            open: true, title: 'Qr',
            children: <Container component="main" maxWidth="sm">
                <QrInfo
                    mac={devices.mac}
                    name={row.name}
                    accountNumber={row.accountNumber}
                    image={row.qr}
                    handleMaskNumberAccount={handleMaskNumberAccount}
                    handlePrintProcess={() => {
                        try {
                            let document = row.fileName
                            const { mac } = devices
                            if (mac !== "NAVEGADOR") {
                                let send = {
                                    type: 'action',
                                    action: 'export_voucher',
                                    data: urlQr + document + '.pdf',
                                    nameFile: 'QR_PAY_' + moment().format("DDMMYYYYHHmmss"),
                                    extension: 'pdf',
                                    messageSend: 'Pago QR'
                                }
                                sendMobile(JSON.stringify(send))
                            } else {
                                handlePrint(document)
                            }
                        } catch (error) {
                            // console.log(error)
                        }
                    }}
                />
            </Container>
        })
    }
    const handleCLoseDialog = () => {
        setDialog({ ...dialog, open: false })
    }
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />
        } else {
            if (codespaginate.length > 0) {
                return <div className={"container"}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Table className={"table"}>
                            <Thead>
                                <Tr className={classes2.divStandard}>
                                    <Th>Nombre</Th>
                                    <Th># de Cuenta</Th>
                                    <Th>Tipo de Cuenta</Th>
                                    <Th>Estado</Th>
                                    <Th>Fecha</Th>
                                    <Th>Opciones</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {
                                    codespaginate.map(row => (
                                        <Tr key={`${row.id}`}>
                                            <Td>{row.name}</Td>
                                            <Td>{handleMaskNumberAccount(row.accountNumber)}</Td>
                                            <Td>{row.typeAccount}</Td>
                                            <Td>{(row.state === true) ? "Activo" : "Inactivo"}</Td>
                                            <Td>{moment(row.createdAt).format("YYYY-MM-DD HH:mm:ss")}</Td>
                                            <Td>
                                                <Grid container style={{ gap: 8 }}>
                                                    <Button variant='contained' style={{ flexGrow: 1, fontSize: 14, height: 40, borderRadius: 10 }} color='primary' aria-label="delete" onClick={() => handleViewVoucher(row)}>
                                                        VER
                                                    </Button>

                                                    <Button variant='outlined' style={{ flexGrow: 1, height: 40, borderRadius: 10 }} color='danger' aria-label="delete" onClick={() => handleChangeStatusQr(row.id)}>
                                                        ELIMINAR
                                                    </Button>
                                                </Grid>
                                            </Td>
                                        </Tr>
                                    ))
                                }
                            </Tbody>
                        </Table>
                        <br />
                        <br />
                        <Pagination
                            count={count}
                            color="standard"
                            page={page}
                            onChange={onChangePaginationCodes}
                        />
                    </Grid>
                </div>
            } else {
                return <Alert severity="info">No se han encontrado qrs generados.</Alert>
            }
        }
    }
    const renderBody = () => {
        return <div style={{
            padding: "20px",
            // borderTop: '2px solid #BEBCC0',
            // borderLeft: '2px solid #BEBCC0',
            borderRadius: "8px",
            // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
        }}>
            <Grid container spacing={3} justifyContent="center" alignItems="center" style={{ textAlign: 'center' }}>
                <Grid item xs={12} md={12} lg={12} sm={12}>
                    <h2>MIS QR's</h2>
                </Grid>
                <Grid item xs={12} md={4} lg={4} sm={12}>
                </Grid>
            </Grid>
            <Grid container spacing={3} justifyContent="center" alignItems="center">
                {
                    renderTableMovements()
                }
            </Grid>
        </div>
    }
    const handleMaskNumberAccount = (numberBeneficiary) => {
        if (numberBeneficiary.length > 4) {
            let resultConvert = ""
            const [a, b, ...dataConvert] = numberBeneficiary
            const inicioFin = dataConvert.length - 2
            const ultimos = dataConvert.join('').slice(inicioFin, dataConvert.length)
            for (let y = 0; y < inicioFin; y++) {
                resultConvert = resultConvert.concat("X")
            }
            resultConvert = a + b + resultConvert + ultimos
            return resultConvert
        } else {
            return numberBeneficiary
        }
    }
    const renderHeader = () => {
        return <div></div>
    }
    return (
        <div>
            <Dashboard
                title="Dashboard"
                body={renderBody()}
                info={renderHeader()}
                multiple={false}
                panel={1}
            />
            <Footer />
            <LoadingScreen open={loading} />
            <StandardDialog
                handleClose={handleCLoseDialog}
                open={dialog.open}
                title={dialog.title}>
                {dialog.children}
            </StandardDialog>
        </div>
    );
};
ReportQr.propTypes = {
};
export default connect(null, { getCodes, sendEmailWithVoucher, findTransferCore })(ReportQr);
